import { ListBodyCellType } from 'views/components/atoms/listCell';
import { BodyShowList } from 'views/components/molecules/listBody';
import { formatDateSlashToJapanese } from 'views/utils/format/FormatDate';
import { formatNumber } from 'views/utils/format/FormatNumber';
import { GetAccountTransactionHistoryQuery } from 'views/utils/graphql/graphql';

export const createBodyShowLists = (data: GetAccountTransactionHistoryQuery) => {
  if (!data.GetAccountTransactionHistory?.Data) return [];

  const createBodyShowList = data.GetAccountTransactionHistory?.Data.map((item) => [

    {
      type: ListBodyCellType.textCell,
      label: formatDateSlashToJapanese(item?.TransactionDate),
    },
    {
      type: ListBodyCellType.sentenceCell,
      label: item?.Debit !== null ? `${item?.Debit}→${item?.Credit}` : `${item.TransactionTypeName}`,
    },
    {
      type: ListBodyCellType.textCell,
      label: item?.AmountDeposit && formatNumber(item?.AmountDeposit) + '円',
    },
    {
      type: ListBodyCellType.textCell,
      label: item?.AmountPayment && formatNumber(item?.AmountPayment) + '円',
    },
    {
      type: ListBodyCellType.textCell,
      label: item?.AmountTransfer && formatNumber(item?.AmountTransfer) + '円',
    },
  ]) as BodyShowList[];
  return createBodyShowList;
};
